import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Services } from 'src/app/services/api.service';

@Component({
  selector: 'app-pdf-tickets-from-email',
  templateUrl: './pdf-tickets-from-email.component.html',
  styleUrls: ['./pdf-tickets-from-email.component.sass'],
  standalone: true,
  imports: [CommonModule]
})
export class PdfTicketsFromEmailComponent {
  t: any;
  b: any;
  id: any;
  ticketsFromMailPDf: any;
  url: any;
  invalidParams: boolean = false;
  
  constructor(private route: ActivatedRoute, private apiService: Services) {}

  ngOnInit() {
    this.t = this.route.snapshot.queryParams["t"];
    this.b = this.route.snapshot.queryParams["b"];
    this.id = this.route.snapshot.queryParams["id"];
    const loader = document.getElementById("loader-container")
    let isTicketDelegation: boolean = false;

    if (window.location.href.includes('pdf-tickets-delegation-from-email')) {
      isTicketDelegation = true;
    }

    this.apiService.getPdfTicketsFromEmail(this.t, this.b, this.id, isTicketDelegation).subscribe({
      next: data => {
        loader!.style.display = "none";
        let response: any = data;
        this.ticketsFromMailPDf = "data:application/pdf;base64," + response.data;
        const byteArray = new Uint8Array(atob(response.data).split('').map(char => char.charCodeAt(0)));
        let blob = new Blob([byteArray], {type: 'application/pdf'});
        this.url = window.URL.createObjectURL(blob);
        window.open(this.url, "_self");      
      },
      error: error => {
        loader!.style.display = "none";
        this.invalidParams = true;
      }});
  }
}